import * as Sentry from '@sentry/browser';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { __ } from '../../utilities';

const OhSnap = styled.div`
  margin: 9rem auto;
  max-width: 600px;
  color: #565656;
  padding: 1em;
`;

const Heading = styled.div`
  font-size: 46px;
  font-weight: bold;
  margin-bottom: 0.4em;
`;

const Description = styled.div`
  font-size: 20px;
  line-height: 1.5;
  margin-left: 0.2em;
`;

class GeneralErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV === 'production') {
      this.setState({ error });
    }
    Sentry.withScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });
  }

  render() {
    if (this.state.error) {
      return (
        <OhSnap>
          <Heading>{__('Ups! Niečo sa pokazilo :(')}</Heading>
          <Description>
            {__(
              'Ospravedlňujeme sa. Chybu sme už zaznamenali a budeme sa jej čo najskôr venovať. Skúste prosím obnoviť stránku, alebo prísť neskôr.',
            )}
          </Description>
        </OhSnap>
      );
    }
    return this.props.children;
  }
}

GeneralErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GeneralErrorBoundary;



// WEBPACK FOOTER //
// ./src/components/GeneralErrorBoundary/index.js